import React from 'react';
// @ts-ignore
import css from './repeatableSegment.module.scss'

const RepeatableSegment = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className={`repeatableSegment`}>
            {children}
        </div>
    );
};

export default RepeatableSegment;